import { NgModule } from '@angular/core';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ChatMoreActionsComponent } from './chat-more-actions/chat-more-actions.component';
import { EmailMoreActionsComponent } from './email-more-actions/email-more-actions.component';
import { EmailComposeMoreActionsComponent } from './email-compose-more-actions/email-compose-more-actions.component';
import { TextChatMoreActionsComponent } from './text-chat-more-actions/text-chat-more-actions.component';
import { EmailControlPanelComponent } from './email-control-panel/email-control-panel.component';

@NgModule({
  imports: [
    SvgIconModule,
    TranslateModule.forChild(),
    CommonModule
  ],
  declarations: [
    ChatMoreActionsComponent,
    EmailMoreActionsComponent,
    EmailComposeMoreActionsComponent,
    TextChatMoreActionsComponent,
    EmailControlPanelComponent
  ],
  exports: [
    ChatMoreActionsComponent,
    EmailMoreActionsComponent,
    EmailComposeMoreActionsComponent,
    TextChatMoreActionsComponent,
    EmailControlPanelComponent
  ]
})

export class WorkWidgetControlPanelModule {}
